import ToggleButton from '../ToggleButton/ToggleButton'
import './DetailsButton.css'

const DetailsButton = ({ detailsShowing, onClick }) => (
  <div className="buttonContainer">
    <ToggleButton toggled={detailsShowing} onClick={onClick}>
      stats
    </ToggleButton>
  </div>
)

export default DetailsButton
